import React from "react";
import FooterBottom from "./footerBottom/FooterBottom";
import FooterTop from "./footerTop/FooterTop";
import "./Footer.scss";

function Footer() {
  return (
    <div className="footer">
      <FooterTop />
      <div className="body-footer">
        <div className="title">DIBEE MARKETPLACE</div>
        <p>
          Sàn thương mại điện tử kết nối người mua và người bán, mang lại trải nghiệm mua sắm trực tuyến an toàn, tiện lợi và hiệu quả.
        </p>
        <p>
          Địa chỉ: Tầng 6,7 Toà nhà Mê Linh Point Tower, Số 2, Đường Ngô Đức Kế, Phường Sài Gòn, TP.HCM.
        </p>
        <p>Số điện thoại: 028 3825 8912</p>
        <p>Email liên hệ: cskh@dibee.co</p>
        <p>Thời gian hỗ trợ: 8:00 - 21:00 (Thứ 2 - Chủ nhật)</p>
      </div>
      <FooterBottom />
    </div>
  );
}

export default Footer;
